// Copyright 2020 Sorama B.V.

import { bindable, customElement } from "aurelia-framework";

@customElement("range-slider")
export class RangeSlider {
    @bindable
    public valueMin: number;

    @bindable
    public valueMax: number;

    @bindable
    public min: number;

    @bindable
    public max: number;

    protected minElement: HTMLDivElement;
    protected maxElement: HTMLDivElement;
    protected sliderElement: HTMLDivElement;

    private minDrag = false;
    private maxDrag = false;

    // This offset allows the right slider handle to never overlap left slider handle.
    private readonly sliderHandleOffset = 0.001;

    protected sliderElementMouseDown = (e) => {
        // Trigger the closest item
        const minEl = this.minElement.getBoundingClientRect();
        const maxEl = this.maxElement.getBoundingClientRect();

        if (Math.abs(e.clientX - minEl.x) <= Math.abs(e.clientX - maxEl.x)) {
            this.minElementDown(e);
        } else {
            this.maxElementDown(e);
        }
    };

    protected mouseMoveCall = (e: MouseEvent) => {
        const rect = this.sliderElement.getBoundingClientRect();
        const val = e.clientX - rect.x;

        if (this.maxDrag) {
            this.valueMax = Math.min(
                this.max,
                Math.max(
                    this.min + (val / this.sliderElement.clientWidth) * (this.max - this.min),
                    this.valueMin + this.sliderHandleOffset * this.valueMin
                )
            );
        } else if (this.minDrag) {
            this.valueMin = Math.max(
                this.min,
                Math.min(this.min + (val / this.sliderElement.clientWidth) * (this.max - this.min), this.valueMax)
            );
        }
    };

    protected minElementDown = (e: MouseEvent) => {
        if (!this.maxDrag) {
            this.minDrag = true;
            document.onmouseup = () => {
                this.minDrag = false;
            };
            document.onmousemove = this.mouseMoveCall;
            this.mouseMoveCall(e);
        }
    };

    protected maxElementDown = (e: MouseEvent) => {
        if (!this.minDrag) {
            this.maxDrag = true;
            document.onmouseup = () => {
                this.maxDrag = false;
            };
            document.onmousemove = this.mouseMoveCall;
            this.mouseMoveCall(e);
        }
    };
}
